//数数ThinkingJS
import global from "../config/global";
import {httpWithRaw, isnull, isNum} from "./tools";

export default class TK {
  static FROM = {
    live: 'live',
    mb: 'multibeam',
    pc: 'private',
  }

  static getFrom(from) {
    if (!isNum(from))
      return from;
    switch (from) {
      case 1:
        return this.FROM.live
      case 2:
        return this.FROM.mb
      case 3:
        return this.FROM.pc
    }
  }

  static track_click_recharge(from) {
    track_TK(global.getUserId(), 'recharge_button_click', {
      from: this.getFrom(from)
    }, global.debug)
  }


  static track_click_room_more(from) {
    track_TK(global.getUserId(), 'more_button_click', {
      from: this.getFrom(from)
    }, global.debug)
  }

  static track_click_game_btm(from) {
    track_TK(global.getUserId(), 'game_button_click', {
      from: this.getFrom(from)
    }, global.debug)
  }

  static track_click_game_banner(from, name) {
    track_TK(global.getUserId(), 'game_banner_click', {
      from: this.getFrom(from),
      banner_name: name
    }, global.debug)
  }

  static track_click_fast_gift(from) {
    track_TK(global.getUserId(), 'fast_gift_button_click', {
      from: this.getFrom(from)
    }, global.debug)
  }

  static track_click_barrage_send(from) {
    track_TK(global.getUserId(), 'barrage_button_click', {
      from: this.getFrom(from)
    }, global.debug)
  }

  static track_click_audience_list(from) {
    track_TK(global.getUserId(), 'click_audience_list', {
      from: this.getFrom(from)
    }, global.debug)
  }

  static track_click_host_list(from) {
    track_TK(global.getUserId(), 'click_host_list', {
      from: this.getFrom(from)
    }, global.debug)
  }

  static track_click_activity_msg() {
    track_TK(global.getUserId(), 'click_activity_message', {}, global.debug)
  }

  static track_click_boss(params) {
    track_TK(global.getUserId(), 'click_boss_button_in_multibeam', params, global.debug)
  }

  static track_confirm_boss(params) {
    track_TK(global.getUserId(), 'confirm_button_in_boss_click', params, global.debug)
  }

  static track_click_announcement(){
    track_TK(global.getUserId(), 'click_announcement', {}, global.debug)
  }

  static track_click_quota(from) {
    track_TK(global.getUserId(), 'track_click_quota', {
      from: this.getFrom(from)
    }, global.debug)
  }

  static track_enter_pure_mode(from) {
    track_TK(global.getUserId(), 'track_enter_pure_mode', {
      from: this.getFrom(from)
    }, global.debug)
  }

  static track_click_banner(from, name) {
    track_TK(global.getUserId(), 'click_banner', {
      from: this.getFrom(from),
      banner_name: name
    }, global.debug)
  }

}

function track_TK(userId, eventName, params = {}, isDebug = false) {
  let time = new Date().format('yyyy-MM-dd hh:mm:ss.S')
  let evP = {
    "#account_id": userId,
    "#time": time,
    "#type": 'track',
    "#event_name": eventName
  }
  params['app_name'] = 'WebHaloLive'
  params['app_channel'] = global.channelId
  params['server_version'] = global.clientVersion
  if (!isnull(params)) {
    evP['properties'] = params
  }

  let finalP = {
    "appid": !isDebug ? 'cbbfdc7254b546a782f3e4125c237e52' : '7b8dd0c8f9a540b0ace58b36710777f6',
    "debug": !isDebug ? 0 : 1,
    "data": evP
  }
  httpWithRaw('https://td.winnerstudio.vip/sync_json', 'POST', finalP, false, (result) => {
    // console.log('track_http_suc:' + result)
  }, (err) => {
    console.log('track_http_failed:' + err)
  }, false, 'application/json;charset=utf-8')
}



// WEBPACK FOOTER //
// ./src/utils/tk.js